import axios from "axios";
import qs from "qs";
import { API_CLIENT_DOMAIN } from "../constants";
import { handleError } from "../errorHandler";

export const getApplicationVersion = (
  id: number,
  onSuccess: Function,
  onFailure: Function
) => {
  axios
    .get(API_CLIENT_DOMAIN + "/version/" + id)
    .then((response) => {
      onSuccess(response.data);
    })
    .catch(function (error) {
      handleError(error, onFailure);
    });
};

export const getApplicationVersionSignings = (
  id: number,
  skip: number,
  limit: number,
  orderingProperty: string,
  orderingDirection: string,
  signingRequestStatusList: string,
  onSuccess: Function,
  onFailure: Function
) => {
  const params = {
    skip: skip,
    limit: limit,
    "ordering[0][property]": orderingProperty,
    "ordering[0][direction]": orderingDirection,
    signingRequestStatusList:
      signingRequestStatusList.length > 0 ? signingRequestStatusList : null,
  };

  axios
    .get(API_CLIENT_DOMAIN + "/version/" + id + "/signing", {
      params,
      paramsSerializer: (params) =>
        qs.stringify(params, { encode: false, skipNulls: true }),
    })
    .then((response) => {
      onSuccess(response.data);
    })
    .catch(function (error) {
      handleError(error, onFailure);
    });
};

export const createApplicationVersionSigning = (
  id: number,
  processor: string,
  environment: string,
  onSuccess: Function,
  onFailure: Function
) => {
  const data = {
    processor: processor,
    environment: environment,
  };

  axios
    .post(API_CLIENT_DOMAIN + "/version/" + id + "/signing", data)
    .then((response) => {
      onSuccess(response.data);
    })
    .catch(function (error) {
      handleError(error, onFailure);
    });
};

export const getApplicationVersionSigningsCount = (
  id: number,
  signingRequestStatusList: string,
  onSuccess: Function,
  onFailure: Function
) => {
  const params = {
    signingRequestStatusList:
      signingRequestStatusList.length > 0 ? signingRequestStatusList : null,
  };

  axios
    .get(API_CLIENT_DOMAIN + "/version/" + id + "/signing/count", {
      params,
      paramsSerializer: (params) =>
        qs.stringify(params, { encode: false, skipNulls: true }),
    })
    .then((response) => {
      onSuccess(response.data.count);
    })
    .catch(function (error) {
      handleError(error, onFailure);
    });
};

export const isSigningRequestUnique = (
  id: number,
  processor: string,
  environment: string,
  onSuccess: Function,
  onFailure: Function
) => {
  const params = {
    processor: processor,
    environment: environment,
  };

  axios
    .get(API_CLIENT_DOMAIN + "/version/" + id + "/signing/unique", {
      params,
    })
    .then((response) => {
      onSuccess(response.data);
    })
    .catch(function (error) {
      handleError(error, onFailure);
    });
};
